import { Directive, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { AbstractControlValueAccessorComponent } from "@app/shared/directive/abstract-control-value-accessor-component.directive";
import { ListaDadItem, ListaDadItemChild, ListaDadItemChildren } from "../components/lista-dad/lista-dad.component";

export type mapValueTypeAbstractInputListaDadComponent<T> = { name: string, list: T[] };

@Directive({})
export abstract class AbstractInputListaDadComponent<T> extends AbstractControlValueAccessorComponent<(T | T[])[]> implements OnChanges {
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["items"] || changes["rowGroupKey"]) {
			this.listaDad = this.convertArrayToListaDad(
				this.items,
				this.rowGroupKey,
				this.getMainGroupName(),
				this.getInfoUtilizzo()
			);
		}
		this.control.setValue([... this.items]);
	}
	@Input() items: T[];

	@Input() rowGroupKey: string;

	@Input() rowIdKey: string;

	listaDad: ListaDadItem<T>;

	protected controlContainer: ControlContainer;
	private disableControlOnChangeValue: boolean = false;
	setRowGroupKey(val:string){
		this.rowGroupKey = val;
	}
	setRowIdKey(val:string){
		this.rowIdKey=val;
	}
	ngOnInit(): void {
		this.control.valueChanges.subscribe(() => {
			if(this.disableControlOnChangeValue)return;
			this.listaDad = this.convertArrayToListaDad(
				this.items, 
				this.rowGroupKey,
				this.getMainGroupName(),
				this.getInfoUtilizzo()
			);
			const checkedElems:any[] = this.control.value? this.control.value.map((v => v[this.rowIdKey])):[];
			this.disableFromListaDadItemsThatNotExist(checkedElems);
			this.orderListaDadItemsByIds(checkedElems);
		});
	}
	private orderListaDadItemsByIds(Ids:any[]){
		if (this.rowIdKey) {
			this.listaDad.children.forEach((group: ListaDadItemChild<T>) => {
				if (group.elem instanceof ListaDadItem) {
					group.elem.children.sort((
						a: ListaDadItemChild<T>,
						b: ListaDadItemChild<T>
					) => {
						const aPos = Ids.indexOf(a.elem[this.rowIdKey]);
						const bPos = Ids.indexOf(b.elem[this.rowIdKey]);
						return aPos - bPos;
					});
				}
			});
		}
	}
	private disableFromListaDadItemsThatNotExist(allowedIds:any[]){
		if (this.rowIdKey) {
			this.listaDad.foreach((
				children: ListaDadItemChildren<T>, 
				child: ListaDadItemChild<T>, 
				childIndex:number
			) =>{
				child.checked = allowedIds.includes(child.elem[this.rowIdKey]);
			});
		}
	}

	private convertArrayToListaDad(items: T[], rowGroupKey: string | undefined, mainGroupName: string, infoUtilizzoString: string) {
		const listaDad: ListaDadItem<T> = new ListaDadItem<T>({
			name: [mainGroupName, infoUtilizzoString].join(" ")
		});
		if (items && items.length > 0) {
			const groupMap: Map<string, mapValueTypeAbstractInputListaDadComponent<T>> = new Map();
			if (rowGroupKey) {
				for (let i = 0; i < items.length; i++) {
					const item: T = items[i];
					let rowGroupKeyValue: string;
					eval("rowGroupKeyValue = item." + rowGroupKey + ";");
					if (!groupMap.has(rowGroupKeyValue)) {
						groupMap.set(rowGroupKeyValue, {
							name: this.getGroupName(item, rowGroupKeyValue),
							list: []
						});
					}
					groupMap.get(rowGroupKeyValue).list.push(item);
				}
			} else {
				groupMap.set("gruppo1", {
					name: this.getGroupName(items[0], "Gruppo"),
					list: []
				});
				groupMap.get("gruppo1").list = [...items];
			}
			this.assignGroupToListaDad(groupMap,listaDad);
		}
		return listaDad;
	}
	protected assignGroupToListaDad(
		groupMap:Map<string, mapValueTypeAbstractInputListaDadComponent<T>>,
		listaDad: ListaDadItem<T>
	):void {
		groupMap.forEach((group) => {
			const listaDadItemGroup:ListaDadItem<T> = new ListaDadItem({name: group.name});
			listaDadItemGroup.addChildren(group.list);
			listaDad.addChild(listaDadItemGroup);
		});
	}

	protected getGroupName(item: T, rowGroupKeyValue?: string) {
		return rowGroupKeyValue;
	}

	protected getInfoUtilizzo(): string {
		return "<i title=\"Trascina i singoli elementi per modificare l'ordine finale. Non verranno considerati nella lista finale gli elementi non selezionati\" class=\"fa fa-info-circle ml-auto\"></i>";
	}

	protected getMainGroupName(): string {
		return "Lista";
	}
	onDragDrop(items: T[]){
		this.disableControlOnChangeValue = true;
		this.setValue(items);
		this.disableControlOnChangeValue = false;
	}
}